module.exports = __webpack_public_path__ + "static/img/co-operate-04.8ab79bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/co-operate-04.png
// module id = qRWn
// module chunks = 1